<template>
  <span class="font-bold" v-if="estimate.length > 0">
    {{ estimatedDateRange() }}
    <span v-if="frameIncluded">
      <p>
        including
        <template v-if="onlyStretching">stretching</template>
        <template v-else>framing</template>
      </p>
    </span>
  </span>
</template>

<script>
import { onlyStretching } from "@/lib/Framing.js"

const FRAME_INCLUDED_DAYS = 4
const INTERNATIONAL_SHIPPING_DAYS = [21]
const SAME_STATE_DAYS = [3, 4]
const OFF_STATE_DAYS = [5, 7]

export default {
  name: "Cart.EstimatedShipping",
  props: {
    item: {
      type: Object,
      required: false,
    },
    listing: {
      type: Object,
      required: false,
    },
    artist: {
      type: Object,
      required: true,
    },
    state: {
      type: String,
      default: "",
    },
    country: {
      type: String,
      default: "AU",
    },
    selectedFrame: {
      type: String,
      default: "",
    },
  },
  computed: {
    locationEstimate() {
      const { metro, state } = this.artist

      if (this.country != "AU") return INTERNATIONAL_SHIPPING_DAYS

      if (this.state == state) {
        return SAME_STATE_DAYS
      } else {
        return OFF_STATE_DAYS
      }

      return []
    },
    estimate() {
      const additionalDays = this.frameIncluded ? FRAME_INCLUDED_DAYS : 0

      return this.locationEstimate.map((day) => day + additionalDays)
    },
    frameIncluded() {
      if (!this.item) {
        return this.selectedFrame != null
      }
      return Boolean(this.item.frame)
    },
    onlyStretching() {
      if (!this.item) {
        return this.selectedFrame == "stretching"
      }
      if (!this.frameIncluded) return false

      return onlyStretching(this.item.frame.option)
    },
    dispatchFromDate() {
      if (this.listing) {
        return this.listing.dispatch_from_date_raw
      }
      return this.item.listing.dispatchFromDate
    },
    afterDate() {
      if (this.artist.holidayMode || this.dispatchFromDate) {
        return this.artist.holidayReturnDate || this.dispatchFromDate
      }
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("en-AU", {
        weekday: "long",
        month: "short",
        day: "numeric",
      }).format(date)
    },
    addDaysToDate(date, days) {
      const result = new Date(date)
      result.setDate(result.getDate() + days)
      return result
    },
    estimatedDateRange() {
      const startDate = this.afterDate ? new Date(this.afterDate) : new Date()
      return `${this.formatDate(this.addDaysToDate(startDate, this.estimate[0]))} - ${this.formatDate(
        this.addDaysToDate(startDate, this.estimate[1]),
      )}`
    },
  },
}
</script>
